import { Notification } from "../atoms/notification";
import { Search } from "../atoms/search";
import { User } from "../atoms/user";
import { SidebarToggle } from '../atoms/sidebartoggle';
import { CreditButton } from "../molecule/creditButton";
import { GoBackButton } from "../atoms/buttons";
import { PageContext } from "../App";
import { useContext } from "react";
import { ip } from "../api/api";
import defaultLogo from "../assets/expligo_logo.png"

export function TopBar({user,notification,onSearchChange,searchValue,goProfile, searchRef, toggleSidebar, activateCredit, isQuizActive,logo, hide= false }){
    var avatarSrc = user.avatar_url ? user.avatar_url : `https://ui-avatars.com/api/?name=${user.full_name}&background=random&color=fff&format=svg`;
    const navigationContext = useContext(PageContext)
    const handleGoBack = () => {
        navigationContext.handleNavigation({ courseID: navigationContext.sidebar.courseID, navigation: 7, enrollment: 0 });
      };
    return(
        !hide && (<div className="horizontal topbar-background-color complete-width space-between clickable-topbar">
           
            {isQuizActive ? ( <></> ) : ( <>  <SidebarToggle toggleSidebar={toggleSidebar} /> <Search inputRef={searchRef} value={searchValue} onChange={onSearchChange} /> </> )}
            {/* <CreditButton activateCredit={activateCredit}/>  */}
            {/* <Notification notifcation={notification}/> */}
            {isQuizActive && ( <img style={{ height: "3.1rem", objectFit: "contain" }}   src={logo ? `${ip}/api/media/${logo}` : defaultLogo}   alt="logo"/>)}
            <User goProfile={goProfile} avatar={avatarSrc} name={user?.full_name} email={user.email}/>
        </div>)
    )
}